import { PAGE_ONE } from "ui/pagination";
import { IPaginationParams } from "ui/pagination/types";

export const ZERO = 0;
export const TWO_DECIMAL_PLACES = 2;
export const ACCOUNT_BALANCE = 520223.07;
export const TOTAL_SAVINGS_BALANCE = 5820223.67;

export const ACCOUNT_TRANSACTIONS_PAGE_LIMIT = 10;

export const DEFAULT_ACCOUNT_TRANSACTIONS_PAGINATION_PARAMS: IPaginationParams =
  {
    limit: ACCOUNT_TRANSACTIONS_PAGE_LIMIT,
    page: PAGE_ONE,
  };

export const INDIVIDUAL_ACCOUNT_NAME_IN_URL_SEPARATOR = "&c&";

export const ALL_INDIVIDUAL_TRANSACTION_TYPE_LIST = ["all", "credit", "debit"];
export const ALL_INDIVIDUAL_SAVINGS_TRANSACTION_TYPE_LIST = [
  "all",
  "savings",
  "interest",
  "withdrawals",
];
export const ALL_INDIVIDUAL_TRANSACTION_STATUS_LIST = [
  "all",
  "successful",
  "pending",
  "failed",
  "reversed",
];
export const ALL_INDIVIDUAL_WORKER_TYPE_LIST = ["all", "employer", "employee"];

export const ALL_INDIVIDUAL_SAVINGS_SOURCE_LIST = ["all", "wallet", "card"];
export const ALL_INDIVIDUAL_SAVINGS_STATUS_LIST = [
  "all",
  "active",
  "completed",
  "paused",
  "stopped",
];
